import React from "react";

const BusinessUnit = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}` }
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M18 29.561h2.91V10.82l9.3 3.95c.534.228.88.749.88 1.326V29.56H34v2.883H2v-2.883h2.91V10.315c0-.57.338-1.086.863-1.317l11.204-4.936A.73.73 0 0 1 18 4.721v24.84Z"
        />
    </svg>
);

export default BusinessUnit;